import axios, { AxiosRequestConfig } from "axios";

// A 401/403 means the access token is missing/expired/rejected: clear the
// session and bounce to sign-in. Any other error is a real failure (network,
// 404, 500, ...) and must not be silently turned into a fake empty success —
// that made failures indistinguishable from "no data" and hid bugs elsewhere.
// Callers are expected to `.catch` (or try/catch) around these calls.
const isAuthError = (err: any) =>
  err && err.response && (err.response.status === 401 || err.response.status === 403);

const handleAuthError = (err: any) => {
  if (isAuthError(err)) {
    console.log("Token Scaduto!");
    sessionStorage.clear();
    window.open("/#/signin", "_self");
  } else {
    console.error("Request failed:", err);
  }
  throw err;
};

export const axiosWithAuth = (url: string, config: AxiosRequestConfig) => {
  let token = sessionStorage.getItem("accessToken");
  if (token !== null) {
    let bearerToken: string = "Bearer " + token;
    const headers = {
      accept: "*/*",
      Authorization: bearerToken,
      "Content-Type": "application/json",
    };
    config.headers = headers;
  } else {
    console.error("Errore, Bearer non trovato!");
  }
  return axios(url, config).catch(handleAuthError);
};

export const axiosWithAuthUpload = (url: string, config: AxiosRequestConfig) => {
  let token = sessionStorage.getItem("accessToken");
  if (token !== null) {
    let bearerToken: string = "Bearer " + token;
    const headers = {
      accept: "*/*",
      Authorization: bearerToken,
      "Content-Type": "image/jpeg",
    };
    config.headers = headers;
  } else {
    console.error("Errore, Bearer non trovato!");
  }
  return axios(url, config).catch(handleAuthError);
};

export const axiosWithUserId = (url: string, config: AxiosRequestConfig) => {
  let token = sessionStorage.getItem("accessToken");
  let userId = sessionStorage.getItem("userId");

  if (token !== null && userId !== null) {
    let bearerToken: string = "Bearer " + token;
    const headers = {
      accept: "*/*",
      Authorization: bearerToken,
      userid: userId,
      "Content-Type": "application/json",
    };
    config.headers = headers;
  } else {
    console.error("Errore: Bearer o userId non trovati!");
  }

  return axios(url, config).catch(handleAuthError);
};
